import React from 'react';
import { ContainerWrapper } from '../../components';
import { Route } from 'react-router-dom';
import ActivitiesList from './ActivitiesList/ActivitiesList';
import ActivityShow from './ActivityShow/ActivityShow';
import ActivityEdit from './ActivityEdit/ActivityEdit';
import ActivityCreate from './ActivityCreate/ActivityCreate';
import ActivityDelete from './ActivityDelete/ActivityDelete';

const Activities = ({ match }) => {
    return (
        <div className="Activities">
            <ContainerWrapper container="activities">
                <Route exact path={ match.path } component={ActivitiesList} />
                <Route exact path={ `${ match.url }/new` } component={ActivityCreate} />
                <Route exact path={ `${ match.url }/show/:activityId` } component={ActivityShow} />
                <Route exact path={ `${ match.url }/edit/:activityId` } component={ActivityEdit} />
                <Route exact path={ `${ match.url }/delete/:activityId` } component={ActivityDelete} />
            </ContainerWrapper>
        </div>
    );
}

export default Activities;
